import React from 'react'
import { ListItem, MenuOverlay, useOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { LeaveGroupOverlay } from '@fs/zion-group-management'
import { useHistory } from '@fs/zion-router'
import { useEvent } from '@fs/zion-frontend-friends'
import { useGroupsContext } from '@fs/zion-tree-groups'
import AssignAdminListItem from './assign-remove-admin/AssignAdminListItem'
import RemoveAdminListItem from './assign-remove-admin/RemoveAdminListItem'
import AssignAsCoOwnerOverlay from './AssignAsCoOwnerOverlay'
import RemoveAsCoOwnerOverlay from './RemoveAsCoOwnerOverlay'
import { useMembersContext } from '../../providers/MembersProvider'

export default function MemberMenuMoreOverlay({
  menuOverlay,
  canAssignAdmin,
  adminCount,
  memberItem,
  isResearcherTree,
  canRemoveAdmin,
  memberItemIsUser,
  removeAdminOverlay,
  canRemoveMember,
  removeMemberOverlay,
  canShowLeaveGroup,
  group,
}) {
  const [t] = useTranslation()
  const assignAsCoOwnerOverlay = useOverlay()
  const removeAsCoOwnerOverlay = useOverlay()
  const { getAndSetGroups } = useGroupsContext()
  const leaveOverlay = useOverlay()
  const { refetchGroupMembers, allMembers, currentMemberDetails } = useMembersContext()
  const onAssignAdmin = refetchGroupMembers
  const onRemoveAdmin = refetchGroupMembers
  const history = useHistory()
  const onLeaveGroup = useEvent(() => {
    getAndSetGroups(true)
    history.push(isResearcherTree ? '/research-tree' : '/family')
  })

  return (
    <>
      {(menuOverlay.isOpen || menuOverlay.transitioning) && (
        <MenuOverlay {...menuOverlay} inline={false}>
          {canAssignAdmin && (
            <AssignAdminListItem
              adminCount={adminCount}
              groupId={group.id}
              member={memberItem}
              onAssignAdmin={onAssignAdmin}
              isResearcherTree={isResearcherTree}
              assignAsCoOwnerOverlay={assignAsCoOwnerOverlay}
            />
          )}

          {canRemoveAdmin && (
            <RemoveAdminListItem
              adminCount={adminCount}
              groupId={group.id}
              memberCisId={memberItem.memberCisId}
              onRemoveAdmin={onRemoveAdmin}
              memberIsSelf={memberItemIsUser}
              isResearcherTree={isResearcherTree}
              memberIsSelfOverlay={removeAdminOverlay}
              removeAsCoOwnerOverlay={removeAsCoOwnerOverlay}
            />
          )}

          {canRemoveMember && (
            <ListItem
              data-testid={`member-list.remove-member-${memberItem.memberCisId}.button`}
              primaryText={t('group-management.remove-member.label', { contactName: memberItem.userProfileName })}
              onClick={removeMemberOverlay.handleClick}
            />
          )}

          {canShowLeaveGroup && (
            <ListItem
              data-testid="leave-group-button"
              primaryText={t('group-management.leave-group.action')}
              onClick={leaveOverlay.handleClick}
            />
          )}
        </MenuOverlay>
      )}

      {(leaveOverlay.isOpen || leaveOverlay.transitioning) && (
        <LeaveGroupOverlay
          isResearchTree={isResearcherTree}
          overlay={leaveOverlay}
          group={group}
          groupMembers={allMembers}
          onLeaveGroup={onLeaveGroup}
          onRemoveAdminSelf={refetchGroupMembers}
          onAdminChange={refetchGroupMembers}
          currentUserCisId={currentMemberDetails?.memberCisId}
        />
      )}

      {(assignAsCoOwnerOverlay.isOpen || assignAsCoOwnerOverlay.transitioning) && (
        <AssignAsCoOwnerOverlay
          overlay={assignAsCoOwnerOverlay}
          groupId={group.id}
          onAssignAdmin={onAssignAdmin}
          member={memberItem}
        />
      )}

      {(removeAsCoOwnerOverlay.isOpen || removeAsCoOwnerOverlay.transitioning) && (
        <RemoveAsCoOwnerOverlay
          overlay={removeAsCoOwnerOverlay}
          groupId={group.id}
          onRemoveAdmin={onRemoveAdmin}
          member={memberItem}
        />
      )}
    </>
  )
}
